<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1"
          >
          <!-- {{
            $router.currentRoute.name == "receipt-description-copy" ? "複製" : ""
          }} -->
          新增發票階段</span
        >
      </h4>

      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- ReceiptDescription id -->
              <b-col cols="12">
                <b-form-group
                  label="款項編號："
                  label-for="id"
                  label-cols-md="3"
                  class="required"
                >   
                  <div class="">
                    {{
                      newReceiptDescriptionData.id
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="款項名稱"
                  rules="required"
                >
                  <b-form-group
                    label="款項名稱："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      type="text"
                      v-model="newReceiptDescriptionData.name"
                      :state="getValidationState(validationContext)"
                      placeholder="款項名稱"
                    />
                  </b-form-group>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col> -->

              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_description"
                >
                <b-form-group
                  label="款項內容"
                  label-for="item_description"
                  label-cols-md="3"
                  class="required"
                >
                <b-form-textarea
                  id="item_description"
                  v-model="newReceiptDescriptionData.description"
                  rows="4"
                  placeholder="輸入款項內容"
                  :state="getValidationState(validationContext)"
                />
                </b-form-group>
                  <b-form-invalid-feedback >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- active -->
              <b-col cols="12">
                <b-form-group
                  label="狀態："
                  label-for="content"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    :checked="newReceiptDescriptionData.is_active"
                    switch
                    inline
                    v-model="newReceiptDescriptionData.is_active"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{
                      newReceiptDescriptionData.is_active ? "啟用" : "禁止"
                    }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- sort_order -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="排序"
                  rules="required"
                >
                  <b-form-group
                    label="排序："
                    label-for="sort_order"
                    label-cols-md="3"
                  >
                    <b-form-input
                      type="number"
                      id="sort_order"
                      v-model="newReceiptDescriptionData.sort_order"
                      placeholder="輸入排序"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { getDateTime } from "@/libs/helper";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  data() {
    return {
      required,
      email,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  methods: {
    hide() {
      this.$router.replace("/settings/receipt-description/list");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.newReceiptDescriptionData.is_active = this.newReceiptDescriptionData.is_active ? 1 : 0;
          store
            .dispatch("receipt-description/editReceiptDescription", this.newReceiptDescriptionData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              // this.$emit("refetch-data");
              // if (this.newReceiptDescriptionData.id == 0) {
              //   this.newReceiptDescriptionData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    ReceiptDescriptionData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newReceiptDescriptionData = ref({
      id: 0,
      name: null,
      description: null,
      is_active: 1,
    });

    watch(
      () => props.ReceiptDescriptionData,
      (newVal) => {
        newReceiptDescriptionData.value = { ...newVal };
      }
    );

    const resetReceiptDescriptionData = () => {
      newReceiptDescriptionData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          name: null,
          description: null,
          is_active: 1,
        })
      );
    };


    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetReceiptDescriptionData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newReceiptDescriptionData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
ol li {
  margin-bottom: 0.5rem;
}
.label-title {
  width: 186px;
}
</style>
